import React from 'react';
import QuestionList from './QuestionList';
import PlotList from './PlotList';
import docs from './data/docs';
import './Quiz.css';

class Quiz extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            matches: this.getQuestions(),
            answers: [false, false, false],
            correct: 'neutral'
        }

        this.setAnswer = this.setAnswer.bind(this); 
        this.checkAnswers = this.checkAnswers.bind(this); 
        this.resetQuestions = this.resetQuestions.bind(this); 
    }

    getQuestions() {
        // 3 random docs
        const shuffledDocs = docs.sort(() => 0.5 - Math.random());
        const selectedDocs = shuffledDocs.slice(0, 4);

        // 3 random colors
        const colors = ['#EF5B5B', '#20A39E', '#FFBA49', '#A4A9AD', '#779ecb', '#6f4685'];
        const shuffledColors = colors.sort(() => 0.5 - Math.random());
        const selectedColors = shuffledColors.slice(0, 4);

        const matches = [
            {
                'color': selectedColors[0],
                'doc'  : selectedDocs[0]
            }, 
            {
                'color': selectedColors[1],
                'doc'  : selectedDocs[1]
            },
            {
                'color': selectedColors[2],
                'doc'  : selectedDocs[2]
            },
            {
                'color': selectedColors[3],
                'doc'  : selectedDocs[3]
            }
        ];
        return matches;
    }

    setAnswer(correct, i) {
        let answers = this.state.answers.slice(0);
        answers[i] = correct;
        this.setState({answers})
    }

    checkAnswers() {
        // check whether we have 3 answers and they are all true
        if (this.state.answers.length === 4 && this.state.answers.filter(ans => ans).length === 4) {
            this.setState({correct: 'correct'});
            
        } else {
            this.setState({correct: 'wrong'})
        }
    }

    resetQuestions() {
        this.setState({correct: 'neutral'})
        this.setState({matches: this.getQuestions()});
    }

    render(){
      let { matches, correct } = this.state;
      return (
        <div className="quiz-container">
             { matches.length > 0 &&
                <QuestionList correct={correct} matches={matches} onSelect={this.setAnswer} onSubmit={this.checkAnswers} onNext={this.resetQuestions}></QuestionList>}
            <PlotList matches={matches}></PlotList>
        </div>);
    }
}

export default Quiz;